// Function to get month name based on index (1-based)
const getMonthNameWithYear = (index) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const monthName = months[index - 1]; // Adjust index to be 0-based for array access
  return `${monthName} ${currentYear}`;
};

export default getMonthNameWithYear;
